import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { xml2js } from "../../json/xml2js";
import queryString from "query-string";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Multiselect } from "react-widgets";
import moment from "moment";
import Comment from "../common/Comment";
import BackIcon from "../common/BackIcon";
import ShareModal from "../common/ShareModal";
import {
  FormSelect,
  FormInput,
  FormCheckbox,
  FormRadioButton,
} from "../common/ControlBundle";
import {
  getConfig,
  getSubmission,
  deleteFormSubmission,
  saveForm,
  saveFormQuietly,
  handleFormChange,
  sendShareEmail,
  validateForm,
  cloneWorkerForm,
  getFieldValue,
  getFieldArray,
  getFieldLabel,
} from "../../scripts/formScriptsv2";
import { ArrayCheck } from "../../scripts/helperScripts";
import { getMergedHomes, getAvailableBintiTags } from "../services/soar";
import { getSchema } from "./joi/validation";
import bintiOptions from "../../options/binti.json";
import ExpandDiv from "../common/ExpandDiv";
import { CSVLink } from "react-csv";

function BulkCaseNotev2() {
  const navigate = useNavigate();

  //Get route and query string params
  const location = useLocation();
  const { formid, submissionid } = useParams();
  const qs = queryString.parse(location);
  console.log("Params", formid, submissionid);
  console.log("QS:", qs);

  //Get logged in user info
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  //The complete Form Submission object with form data
  const [formsyDetails, setFormsyDetails] = useState({});
  const [formsyConfig, setFormsyConfig] = useState({});
  const [loadingConfig, setLoadingConfig] = useState(false);
  //The form data and previous forms
  const [data, setData] = useState({});
  //Touched fields
  const [touched, setTouched] = useState({});
  const [isSaveInProgress, setIsSaveInProgress] = useState(false);
  //Errors
  const [errors, setErrors] = useState({});

  //Signatures State Property
  const [signatures, setSignatures] = useState([]);
  //Comments state Property
  const [comments, setComments] = useState();
  //Show Comments Modal
  const [showComment, setShowComment] = useState(false);
  //Show Share Modal
  const [showShare, setShowShare] = useState(false);
  //Show Form Level (not field specific) Comments
  const [showFormComment, setShowFormComment] = useState(false);

  const [timeoutId, setTimeoutId] = useState();

  const pdfRef = useRef(true);
  const isMountedRef = useRef(true);

  //Get validation schema
  const schema = getSchema(formid); // Latest Form Version Id
  console.log("Schema Config: ", schema);

  const formDisabled = useMemo(() => {
    return formsyDetails.Active === "0" || formsyDetails.FinalSigned === "1";
  }, [formsyDetails]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      pdfRef.current = false;
    };
  }, []);

  //Get Client Info
  useEffect(() => {
    if (!submissionid) {
      return;
    }

    const loadSubmission = async () => {
      const response = await getSubmission(submissionid);

      if (!isMountedRef.current || !response) {
        return;
      }

      setData(response.Data);
      setFormsyDetails(response.FormsyDetails);

      if (response.Comments) {
        setComments(response.Comments);
      }

      if (response.Signatures) {
        setSignatures(response.Signatures);
      }
    };

    loadSubmission();
  }, [submissionid]);

  useEffect(() => {
    if (
      Object.keys(formsyConfig).length > 0 ||
      loadingConfig ||
      !safyInfo?.user
    ) {
      return;
    }

    const loadConfig = async () => {
      setLoadingConfig(true);
      const response = await getConfig(formid);

      if (!isMountedRef.current || !response) {
        return;
      }

      setFormsyConfig(response);

      if (!submissionid) {
        //Set Formsy Details
        const newForm = {
          SubmissionId: "",
          FormId: response.FormId,
          FormVersionId: formid,
          ContactId: "",
          ContactName: "",
          ClientProgramId: "",
          ClientProgramName: "",
          TertiaryObjectId: "",
          TertiaryObjectName: "",
          FormResults: {
            results: {},
          },

          Comments: "",
          Signatures: "",
          CreatedOn: "",
          CreatedById: safyInfo.user.azureId,
          CreatedByName: safyInfo.user.displayName,
          ModifiedById: safyInfo.user.azureId,
          ModifiedByName: safyInfo.user.displayName,
          FinalSigned: "0",
          FinalSignedDate: "",
          Active: "1",
        };
        setFormsyDetails(newForm);
        setData(response.FormConfiguration[0].config[0]);
        setLoadingConfig(false);

        console.log("New Form:", newForm);
        console.log(
          "loadConfig setData:",
          response.FormConfiguration[0].config[0]
        );
      }
    };

    loadConfig();
  }, [formid, loadingConfig, safyInfo?.user, formsyConfig, submissionid]);

  useEffect(() => {
    if (!submissionid || !!formsyDetails.SubmissionId) {
      return;
    }

    const obj = { ...formsyDetails };
    obj.SubmissionId = submissionid;
    setFormsyDetails(obj);
  }, [submissionid, formsyDetails]);

  //Form validation
  const handleChange = ({ currentTarget: input }) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const result = handleFormChange(input, data, schema, errors);
    setData(result.Data);
    setErrors(result.Errors);

    if (!submissionid) {
      return result.Data;
    }

    const touchedObj = { ...touched, [input.name]: true };
    const touchedFields = Object.keys(touchedObj).filter(
      (field) => touchedObj[field]
    );

    if (touchedFields.length >= 5) {
      if (isSaveInProgress) {
        const toId = setTimeout(() => {
          touchedFields.forEach((field) => (touchedObj[field] = false));
          handleSubmit(result.Data, null, null, null, true);
        }, 20000);

        setTimeoutId(toId);
      } else {
        clearTimeout(timeoutId);
        handleSubmit(result.Data, null, null, null, true);
        touchedFields.forEach((field) => (touchedObj[field] = false));
      }
    } else {
      const toId = setTimeout(() => {
        if (isSaveInProgress) {
          const toId2 = setTimeout(() => {
            touchedFields.forEach((field) => (touchedObj[field] = false));
            handleSubmit(result.Data, null, null, null, true);
          }, 20000);

          setTimeoutId(toId2);
        } else {
          touchedFields.forEach((field) => (touchedObj[field] = false));
          handleSubmit(result.Data, null, null, null, true);
        }
      }, 20000);

      setTimeoutId(toId);
    }

    setTouched(touchedObj);
    return result.Data;
  };

  ////SAVE
  const handleSubmit = async (
    dataOverride,
    formsyDetailsOverride,
    commentsOverride,
    signaturesOverride,
    autoSave = false
  ) => {
    if (isSaveInProgress) {
      return;
    }

    const dataObj = dataOverride || data;
    const formsyDetailsObj = formsyDetailsOverride || formsyDetails;
    const commentsObj =
      commentsOverride === undefined ? undefined : commentsOverride || comments;
    const signaturesObj = signaturesOverride || signatures;

    if (
      !getFieldValue(dataObj.SelectedState) &&
      userBusinessUnit !== "ccplive"
    ) {
      dataObj.SelectedState.value = userBusinessUnit
        .replace("SAFY of ", "")
        .replace(" ", "")
        .toLowerCase();
      setData(dataObj);
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTouched({});
    setIsSaveInProgress(true);

    try {
      const submissionResponse = await saveForm(
        dataObj,
        formsyDetailsObj,
        commentsObj,
        signaturesObj,
        navigate,
        location,
        autoSave
      );

      if (!isMountedRef.current || !submissionResponse?.Id) {
        return;
      }

      const newDetails = { ...formsyDetailsObj };
      newDetails.ModifiedOn = submissionResponse.LastModifiedOn;
      newDetails.ModifiedById = safyInfo.user.azureId;
      newDetails.ModifiedByName = safyInfo.user.displayName;

      if (newDetails.SubmissionId === "") {
        newDetails.SubmissionId = submissionResponse?.Id;
      }

      setFormsyDetails(newDetails);
    } finally {
      setIsSaveInProgress(false);
    }
  };

  ////SHARE
  // const toggleShareModal = () => {
  //   setShowShare(!showShare);
  // };

  const handleShareSend = (recipientList, shareComments) => {
    sendShareEmail(
      recipientList,
      shareComments,
      location.pathname,
      data,
      formsyDetails,
      comments,
      signatures,
      formsyConfig.FormDescription
    );
  };

  ////COMMENTS FUNCTIONALITY
  const [commentToEdit, setCommentToEdit] = useState();

  const toggleCommentModal = (editComment) => {
    if (!showComment && editComment) setCommentToEdit(editComment);
    setShowComment(!showComment);
  };

  const handleComments = ({ action, fieldName, comment, acknowledge }) => {
    if (action === "ADD") {
      setShowComment(true);
    } else if (comment !== undefined) {
      if (action === "EDIT") {
        toggleCommentModal(comment);
      } else if (action === "DELETE") {
        handleDeleteComment(comment);
      } else if (action === "ACKNOWLEDGE" && acknowledge !== undefined) {
        handleAcknowledgeComment(comment, acknowledge);
      }
    } else if (action === "GET") {
      return parsedComments.filter(
        (comment) => comment.field._text === fieldName
      );
    }
  };

  const commentFields = () => {
    let commentOptions = [];
    commentOptions.push({ _id: "EntireForm", name: "Entire Form----" });
    for (const property in data) {
      if (
        data[property].type !== "section" &&
        data[property].type !== "label" &&
        data[property].type !== "User" &&
        data[property].type !== "hidden"
      ) {
        const option = {
          _id: property,
          name: getFieldLabel(data[property]) || property,
        };
        commentOptions.push(option);
      }
    }
    return commentOptions;
  };

  const parsedComments = useMemo(() => {
    if (!comments) {
      return [];
    }

    const commentObj = xml2js(`<comments type="array">${comments}</comments>`, {
      compact: true,
      spaces: 4,
    });

    return ArrayCheck(commentObj.comments.comment);
  }, [comments]);

  const onCommentSave = (comment, commentToEdit) => {
    let formsyComments;
    if (commentToEdit) {
      const commentXml = `<comment><createdby>${
        commentToEdit.createdby._text
      }</createdby><datetime>${commentToEdit.datetime._text}</datetime><field>${
        commentToEdit.field._text
      }</field><comment>${commentToEdit.comment._text}</comment>${
        commentToEdit.acknowledgedby
          ? `<acknowledgedby>${commentToEdit.acknowledgedby._text}</acknowledgedby><acknowledgedon>${commentToEdit.acknowledgedon._text}</acknowledgedon>`
          : ""
      }</comment>`;
      console.log("CurrentCommentsXML: ", comments);
      console.log("CommentToReplace: ", commentXml);
      console.log("CommentToEdit: ", commentToEdit);
      console.log("CommentToEditXML: ", comment);

      formsyComments =
        comments !== undefined
          ? comments.replace(commentXml, comment)
          : comment;
      setComments(formsyComments);
    } else {
      formsyComments = comments !== undefined ? comments + comment : comment;
      setComments(formsyComments);
    }

    setShowComment(false);
    handleSubmit(null, null, formsyComments, null);
    setCommentToEdit(undefined);
  };

  const handleDeleteComment = (comment) => {
    const commentXml = `<comment><createdby>${
      safyInfo.user.displayName
    }</createdby><datetime>${comment.datetime._text}</datetime><field>${
      comment.field._text
    }</field><comment>${comment.comment._text}</comment>${
      comment.acknowledgedby
        ? `<acknowledgedby>${comment.acknowledgedby._text}</acknowledgedby><acknowledgedon>${comment.acknowledgedon._text}</acknowledgedon>`
        : ""
    }</comment>`;

    let formsyComments = comments.replace(commentXml, "");
    if (formsyComments === "") formsyComments = undefined;
    setComments(formsyComments);
    handleSubmit(null, null, formsyComments, null);
  };

  const toggleCommentToEdit = (comment) => {
    setCommentToEdit(comment);
    setShowComment(true);
  };

  const handleAcknowledgeComment = (comment, acknowledge) => {
    if (acknowledge) {
      const oldCommentXML = `<comment><createdby>${comment.createdby._text}</createdby><datetime>${comment.datetime._text}</datetime><field>${comment.field._text}</field><comment>${comment.comment._text}</comment></comment>`;
      const newCommentXML = `<comment><createdby>${
        comment.createdby._text
      }</createdby><datetime>${comment.datetime._text}</datetime><field>${
        comment.field._text
      }</field><comment>${comment.comment._text}</comment><acknowledgedby>${
        safyInfo.user.displayName
      }</acknowledgedby><acknowledgedon>${moment().format(
        "L"
      )} ${moment().format("LT")}</acknowledgedon></comment>`;
      const formsyComments = comments.replace(oldCommentXML, newCommentXML);
      setComments(formsyComments);
      handleSubmit(null, null, formsyComments, null);
    } else {
      const oldCommentXML = `<comment><createdby>${comment.createdby._text}</createdby><datetime>${comment.datetime._text}</datetime><field>${comment.field._text}</field><comment>${comment.comment._text}</comment><acknowledgedby>${comment.acknowledgedby._text}</acknowledgedby><acknowledgedon>${comment.acknowledgedon._text}</acknowledgedon></comment>`;
      const newCommentXML = `<comment><createdby>${comment.createdby._text}</createdby><datetime>${comment.datetime._text}</datetime><field>${comment.field._text}</field><comment>${comment.comment._text}</comment></comment>`;
      const formsyComments = comments.replace(oldCommentXML, newCommentXML);
      setComments(formsyComments);
      handleSubmit(null, null, formsyComments, null);
    }
  };

  const handleCommentNavigation = (fieldName) => {
    const element = document.getElementById(fieldName);
    if (element.type === "checkbox")
      scrollTo(
        document.getElementById(fieldName).parentElement.parentElement
          .parentElement.offsetTop - 50,
        () => {
          document.getElementById(fieldName).focus();
        }
      );
    else
      scrollTo(document.getElementById(fieldName).offsetTop - 50, () => {
        document.getElementById(fieldName).focus();
      });
  };

  const renderComments = () => {
    return parsedComments
      .filter(
        (comment) =>
          comment.field._text === "EntireForm" ||
          comment.field._text === "Entire Form----"
      )
      .map((comment, index) => (
        <div className="mt-2" key={`form-comment-${index}`}>
          {showFormComment && (
            <div
              className={`${
                comment.acknowledgedby ? "bg-safy3-50" : "bg-warning"
              } p-2 m-2 rounded d-print-none`}
              title={
                comment.acknowledgedby
                  ? `Acknowledged by: ${comment.acknowledgedby._text} ${comment.acknowledgedon._text}`
                  : ""
              }
            >
              <span className="h6">
                {comment.createdby._text ===
                  JSON.parse(localStorage.getItem("safyInfo")).user
                    .displayName && (
                  <>
                    <i
                      title="Delete Comment"
                      className="far fa-trash-alt text-white me-2"
                      onClick={() => {
                        confirmAlert({
                          title: "Delete Comment",
                          message:
                            "Are you sure you want to delete this comment?",
                          buttons: [
                            {
                              label: "Yes",
                              onClick: () => {
                                handleDeleteComment(comment);
                              },
                            },
                            {
                              label: "No",
                              onClick: () => {
                                /* do nothing */
                              },
                            },
                          ],
                        });
                      }}
                    ></i>
                    {!comment.acknowledgedby && (
                      <i
                        title="Edit Comment"
                        className="fas fa-pen text-white me-2"
                        onClick={(e) => {
                          toggleCommentToEdit(comment);
                        }}
                      ></i>
                    )}
                  </>
                )}
                {comment.acknowledgedby && (
                  <i
                    className="far fa-check-square text-white me-2"
                    onClick={() => {
                      if (
                        comment.acknowledgedby._text ===
                        JSON.parse(localStorage.getItem("safyInfo")).user
                          .displayName
                      )
                        handleAcknowledgeComment(comment, false);
                    }}
                  ></i>
                )}
                {!comment.acknowledgedby && (
                  <i
                    className="far fa-square text-white me-2"
                    onClick={() => {
                      handleAcknowledgeComment(comment, true);
                    }}
                    title="Acknowledge Comment"
                  ></i>
                )}
                <br />
                {`${comment.createdby._text} - ${comment.datetime._text}`}
              </span>
              <br />
              Regarding:{" "}
              {comment.field._text !== "EntireForm" &&
              comment.field._text !== "Entire Form----" ? (
                <button
                  className="btn btn-link"
                  onClick={() => {
                    setTimeout(() => {
                      handleCommentNavigation(comment.field._text);
                    }, 100);
                  }}
                >
                  {comment.field._text}
                </button>
              ) : (
                <>{comment.field._text}</>
              )}
              <br />
              {comment.comment._text}
            </div>
          )}
        </div>
      ));
  };

  function scrollTo(offset, callback) {
    const fixedOffset = offset.toFixed();
    const onScroll = function () {
      if (window.pageYOffset.toFixed() === fixedOffset) {
        window.removeEventListener("scroll", onScroll);
        callback();
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();
    window.scrollTo({
      top: offset,
      behavior: "smooth",
    });
  }

  //CUSTOM
  const [assignment, setAssignment] = useState("state");
  const [filterType, setFilterType] = useState("applying");
  const [allStatuses, setAllStatuses] = useState(false);
  const [additionalFilters, setAdditionalFilters] = useState([]);
  const [tagFilters, setTagFilters] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const [bintiApplications, setBintiApplications] = useState([]);
  const [homesLoadStatus, setHomesLoadStatus] = useState({});

  useEffect(() => {
    if (
      !data.UserBintiId ||
      getFieldValue(data.UserBintiId) ||
      !safyInfo?.user?.safyInfo?.BusinessUnitIdName ||
      !safyInfo.user.safyInfo.binti?.filter
    ) {
      return;
    }

    let userState;
    if (safyInfo.user.safyInfo.BusinessUnitIdName === "ccplive") {
      if (!getFieldValue(data.SelectedState)) {
        return;
      }

      userState = getFieldValue(data.SelectedState);
    } else {
      userState = safyInfo.user.safyInfo.BusinessUnitIdName.replace(
        "SAFY of ",
        ""
      )
        .replace(" ", "")
        .toLowerCase();
    }

    const bintiState = safyInfo.user.safyInfo.binti.filter(
      (b) => b.company === userState
    )[0];

    if (!bintiState) {
      return;
    }

    const obj = { ...data };
    obj.UserBintiId.value = bintiState.id;
    setData(obj);
  }, [data, safyInfo]);

  const userBusinessUnit = useMemo(() => {
    if (!safyInfo?.user?.safyInfo?.BusinessUnitIdName) {
      return;
    }

    return safyInfo.user.safyInfo.BusinessUnitIdName;
  }, [safyInfo]);

  const userIsAdmin = useMemo(() => {
    if (!safyInfo?.user?.modules) {
      return false;
    }

    return safyInfo.user.modules.includes("Admin");
  }, [safyInfo]);

  const recipientOptions = useMemo(() => {
    const options = bintiApplications.map((app) => {
      const primaryContact = app.HomeData[0].members.filter(
        (mem) => mem.primarycontact === "Yes"
      )[0];

      return {
        _id: primaryContact.contactid,
        name: app.HomeData[0].fostercarehomename,
        firstname: primaryContact.firstname,
        lastname: primaryContact.lastname,
        emailaddress1: primaryContact.emailaddress1,
        inquirydate: app.HomeData[0].inquirydate,
      };
    });

    return options;
  }, [bintiApplications]);

  const loadMergedHomes = async (state) => {
    setHomesLoadStatus({ loading: true });
    const toastId = toast.loading("Loading Binti Applicants...", {
      type: toast.TYPE.INFO,
    });
    const response = await Promise.all([
      getMergedHomes(state),
      getAvailableBintiTags(state),
    ]);

    if (response?.length === 2) {
      setBintiApplications(JSON.parse(response[0]));
      setHomesLoadStatus({ loaded: true });
      const allTags = JSON.parse(response[1]).tags;
      const tags = allTags.map((t) => t.tag);
      setAvailableTags(tags);
    }

    if (!isMountedRef.current) {
      toast.dismiss(toastId);
      return;
    }

    toast.update(toastId, {
      render: "Binti Applicants loaded.",
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      autoClose: 5000,
      closeOnClick: true,
    });
  };

  useEffect(() => {
    if (
      homesLoadStatus.loaded ||
      homesLoadStatus.loading ||
      !userBusinessUnit
    ) {
      return;
    }

    if (userBusinessUnit === "ccplive") {
      getFieldValue(data.SelectedState) &&
        loadMergedHomes(getFieldValue(data.SelectedState));
    } else {
      const userState = userBusinessUnit
        .replace("SAFY of ", "")
        .replace(" ", "")
        .toLowerCase();
      loadMergedHomes(userState);
    }
  }, [homesLoadStatus, data, userBusinessUnit, loadMergedHomes]);

  const handleSelectedRecipientsChange = (items) => {
    const e = {
      currentTarget: {
        name: "SelectedRecipients",
        value: JSON.stringify(items.map((item) => item._id)),
        type: "multiselect",
      },
    };
    handleChange(e);
  };

  const needsContactMethod = useMemo(() => {
    if (!data.Type) {
      return false;
    }

    const value = getFieldValue(data.Type);

    return (
      value === "case_update" ||
      value === "next_planned_contact" ||
      value === "other" ||
      value === "recruiting" ||
      value === "family_evaluation"
    );
  }, [data]);

  const validate = () => {
    const results = validateForm(data, schema);

    if (getFieldValue(data.Type) === "next_planned_contact") {
      if (results.Date) {
        setErrors(results);
        return results;
      }

      const now = moment().startOf("day");
      const nextDate = moment(getFieldValue(data.Date));
      if (nextDate.isBefore(now)) {
        const errs = { ...results };
        errs.Date = "Date cannot be in the past.";
        setErrors(errs);
        return errs;
      }
    }

    setErrors(results);
    return results;
  };

  const markFinalSigned = async () => {
    if (Object.keys(validate()).length > 0) {
      return;
    }

    const toastId = toast.loading("Submitting...");
    const details = { ...formsyDetails };
    details.FinalSigned = "1";
    details.FinalSignedDate = new Date();
    setFormsyDetails(details);

    if (getFieldValue(data.NeedNext) === "true") {
      saveFormQuietly(data, details, comments, signatures, navigate, location);
      const nextData = { ...data };
      nextData.Type.value = "next_planned_contact";
      nextData.Date.value = getFieldValue(data.NextContactDate);
      nextData.Subject.value = getFieldValue(data.NextContactSubject);
      nextData.ContactMethod.value = getFieldValue(data.NextContactMethod);
      nextData.Body.value = getFieldValue(data.NextContactBody);
      delete nextData.NeedNext.value;
      delete nextData.NextContactDate.value;
      delete nextData.NextContactSubject.value;
      delete nextData.NextContactMethod.value;
      delete nextData.NextContactBody.value;
      const cloneResponse = await cloneWorkerForm(
        nextData,
        details,
        comments,
        signatures,
        location,
        formsyConfig
      );

      if (cloneResponse) {
        const nextDetails = { ...details };
        nextDetails.SubmissionId = cloneResponse;
        await saveFormQuietly(
          nextData,
          nextDetails,
          comments,
          signatures,
          undefined,
          location
        );

        toast.update(toastId, {
          render: "Submitted successfully",
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeOnClick: true,
        });
      }
    } else {
      toast.update(toastId, {
        render: "An error has occurred...",
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeOnClick: true,
      });
    }
  };

  ////DELETE
  const handleDelete = (e) => {
    e.preventDefault();
    deleteFormSubmission(
      data,
      formsyDetails,
      comments,
      signatures,
      navigate,
      location
    );
  };

  const handleSelectedStateChange = async ({ currentTarget: input }) => {
    const obj = { ...data };
    obj.SelectedState.value = input.value;
    setData(obj);

    if (!input.value) {
      return;
    }

    setBintiApplications([]);
    const response = await loadMergedHomes(input.value);

    if (response && response !== "") {
      const allApps = JSON.parse(response);
      const filtered = allApps.sort((a, b) =>
        a.HomeData[0].createdon < b.HomeData[0].createdon ? 1 : -1
      );
      setBintiApplications(
        filtered.map((app) => app.HomeData[0].fostercarehomename)
      );
    }
  };

  const getAdditionalFilterClass = (item) => {
    return additionalFilters.includes(item)
      ? "btn btn-sm btn-success m-1"
      : "btn btn-sm btn-safy-info m-1";
  };
  const getTagFilterClass = (item) => {
    return tagFilters.includes(item)
      ? "btn btn-sm btn-success m-1"
      : "btn btn-sm btn-safy-info m-1";
  };

  const addRemoveAdditionalFilter = (item) => {
    const af = [...additionalFilters];
    const index = af.indexOf(item);

    if (index === -1) {
      af.push(item);
    } else {
      af.splice(index, 1);
    }
    setAdditionalFilters(af);
  };

  const addRemoveTagFilter = (item) => {
    const tf = [...tagFilters];
    const index = tf.indexOf(item);

    if (index === -1) {
      tf.push(item);
    } else {
      tf.splice(index, 1);
    }
    setTagFilters(tf);
  };

  const clearStatusRelatedFilters = () => {
    const af = [...additionalFilters];
    if (af.indexOf("ALD-PAST30") !== -1) {
      af.splice(af.indexOf("ALD-PAST30"));
    }
    if (af.indexOf("ALD-30") !== -1) {
      af.splice(af.indexOf("ALD-30"));
    }
    if (af.indexOf("RECERT-60") !== -1) {
      af.splice(af.indexOf("RECERT-60"));
    }
    setAdditionalFilters(af);
  };

  const filteredData = useMemo(() => {
    const filteredHomes = bintiApplications.filter((app) => {
      const primaryContactId = app.HomeData[0].members.filter(
        (mem) => mem.primarycontact === "Yes"
      )[0];

      if (!primaryContactId) {
        return false;
      }

      if (assignment === "unassigned" && app.HomeData[0].workers.length > 0) {
        return false;
      }

      if (assignment === "my") {
        if (!safyInfo?.user) {
          return false;
        }

        if (
          app.HomeData[0].workers.filter(
            (w) => w.worker_name === safyInfo.user.displayName
          ).length === 0
        ) {
          return false;
        }
      }

      if (
        filterType !== "In Renewal" &&
        app.HomeData[0].status.toLowerCase() !== filterType.toLowerCase()
      ) {
        return false;
      }

      if (
        filterType === "In Renewal" &&
        `${app.HomeData[0].type}${app.HomeData[0].status}` !==
          "RenewalApplicationapplying"
      ) {
        return false;
      }

      if (additionalFilters.length > 0) {
        const checkFunctions = {
          "NCD-PAST": (homeData) => {
            // Filter out if Next Contact Date is not in the past
            if (!homeData.next_contact[0]?.case_note_date) {
              return false;
            }

            const today = moment();
            const caseNoteDate = moment(
              homeData.next_contact[0].case_note_date
            );

            if (today.isBefore(caseNoteDate)) {
              return false;
            }

            return true;
          },
          "NCD-7": (homeData) => {
            // Filter ouf if the Next Contact Date is not within the next 7 days
            if (!homeData.next_contact[0]?.case_note_date) {
              return false;
            }

            const today = moment();
            const caseNoteDate = moment(
              homeData.next_contact[0].case_note_date
            );

            if (
              today.isAfter(caseNoteDate) ||
              today.add(7, "days").isBefore(caseNoteDate)
            ) {
              return false;
            }

            return true;
          },
          "LCD-30": (homeData) => {
            // Filter out if Last Contact Date is greater than 30 days prior
            if (!homeData.last_contact[0]?.case_note_date) {
              return false;
            }

            const today = moment();
            const caseNoteDate = moment(
              homeData.last_contact[0].case_note_date
            );

            if (
              today.isAfter(caseNoteDate) ||
              today.add(7, "days").isBefore(caseNoteDate)
            ) {
              return false;
            }

            return true;
          },
          "NOLCD": (homeData) => {
            // Filter ot if Last Contact Date existx
            if (homeData.last_contact[0]?.case_note_date) {
              return false;
            }

            return true;
          },
          "TRAINING": (homeData) => {
            // Filter out if No Attended Trainings
            if (!homeData.last_contact[0]?.last_attended_training) {
              return false;
            }

            if (homeData.last_contact[0].last_attended_training.length === 0) {
              return false;
            }

            return true;
          },
          "ALD-PAST30": (homeData) => {
            // Filter out if Approval Date is not in the past 30 days
            if (
              !homeData?.status ||
              !homeData.approval_date_estimate?.[0]?.case_note_date
            ) {
              return false;
            }

            if (
              homeData.status !== "applying" &&
              homeData.status !== "recruiting"
            ) {
              return false;
            }

            const today = moment();
            const thirtyDaysAgo = moment().add(-30, "days");
            const caseNoteDate = moment(
              homeData.approval_date_estimate[0].case_note_date
            );

            if (
              today.isBefore(caseNoteDate) ||
              thirtyDaysAgo.isAfter(caseNoteDate)
            ) {
              return false;
            }

            return true;
          },
          "ALD-30": (homeData) => {
            // Filter out if Approval Date is not within the next 30 days
            if (
              !homeData?.status ||
              !homeData.approval_date_estimate?.[0]?.case_note_date
            ) {
              return false;
            }

            if (
              homeData.status !== "applying" &&
              homeData.status !== "recruiting"
            ) {
              return false;
            }

            const today = moment();
            const thirtyDaysFromNow = moment().add(30, "days");
            const caseNoteDate = moment(
              homeData.approval_date_estimate[0].case_note_date
            );

            if (
              today.isAfter(caseNoteDate) ||
              thirtyDaysFromNow.isBefore(caseNoteDate)
            ) {
              return false;
            }

            return true;
          },
          "RECERT-60": (homeData) => {
            // Filter out if Renewal Date is not within the next 60 days
            if (!homeData.renewaldate) {
              return false;
            }

            const today = moment();
            const sixtyDaysFromNow = moment().add(60, "days");
            const caseNoteDate = moment(homeData.renewaldate);

            if (
              today.isAfter(caseNoteDate) ||
              sixtyDaysFromNow.isBefore(caseNoteDate)
            ) {
              return false;
            }

            return true;
          },
        };

        const failedFilters = additionalFilters.filter(
          (f) => !checkFunctions[f](app.HomeData[0])
        );

        if (failedFilters.length > 0) {
          return false;
        }
      }

      if (tagFilters.length > 0) {
        const failedTags = tagFilters.filter(
          (t) => !app.HomeData[0].tags.includes(t)
        );

        if (failedTags.length > 0) {
          return false;
        }
      }

      return true;
    });

    return filteredHomes
      .sort((a, b) =>
        a.HomeData[0].fostercarehomename < b.HomeData[0].fostercarehomename
          ? -1
          : 1
      )
      .map((app) => {
        const primaryContact = app.HomeData[0].members.filter(
          (mem) => mem.primarycontact === "Yes"
        )[0];

        return primaryContact.contactid;
      });
  }, [bintiApplications, assignment, filterType, additionalFilters, safyInfo]);

  const getFilterCount = useCallback(
    (filter) => {
      let filterCount = 0;
      if (filter === "In Renewal") {
        filterCount = bintiApplications.filter(
          (app) =>
            `${app.HomeData[0].type}${app.HomeData[0].status}` ===
            "RenewalApplicationapplying"
        ).length;
      } else if (filter === "Recruiting Dropout") {
        filterCount = bintiApplications.filter(
          (app) => app.HomeData[0].status === "recruiting_dropout"
        ).length;
      } else {
        filterCount = bintiApplications.filter(
          (app) => app.HomeData[0].status === filter.toLowerCase()
        ).length;
      }

      return `${filter} ${filterCount}`;
    },
    [bintiApplications]
  );

  const handleSelectAll = useCallback(() => {
    console.log(filteredData);
    setData((d) => {
      const obj = { ...d };
      const selected = getFieldArray(obj.SelectedRecipients);
      obj.SelectedRecipients.value = JSON.stringify([
        ...new Set(selected.concat(filteredData)),
      ]);
      return obj;
    });
  }, [filteredData]);

  const handleClearAll = () => {
    setData((d) => {
      const obj = { ...d };
      obj.SelectedRecipients.value = JSON.stringify([]);
      return obj;
    });
  };

  const csvData = useMemo(() => {
    if (Object.keys(validateForm(data, schema)).length > 0) {
      return [];
    }

    const selected = getFieldArray(data.SelectedRecipients);
    const result = selected.map((id) => {
      const recipientOption = recipientOptions.filter(
        (app) => app._id === id
      )[0];

      return {
        firstname: recipientOption.firstname,
        lastname: recipientOption.lastname,
        email: recipientOption.emailaddress1,
        inquirydate: recipientOption.inquirydate,
      };
    });

    return result;
  }, [recipientOptions, data]);

  useEffect(() => {
    if (!data.Body?.value) {
      return;
    }

    setData((d) => {
      const replaced = d.Body.value.replaceAll('"', "'");

      if (d.Body.value === replaced) {
        return d;
      }

      const obj = { ...d };
      obj.Body.value = replaced;
      return obj;
    });
  }, [data.Body?.value]);

  ////UI
  return (
    <>
      <div className="mb-2">
        <BackIcon />
      </div>
      <div className={!submissionid ? "watermarked" : ""} ref={pdfRef}>
        {renderComments()}
        {parsedComments.filter(
          (comment) =>
            comment.field._text === "EntireForm" ||
            comment.field._text === "Entire Form----"
        ).length > 0 && (
          <i
            className="fas fa-comment-alt text-warning float-end mb-2 ms-2"
            onClick={() => setShowFormComment(!showFormComment)}
          ></i>
        )}
        <div className="mt-4">
          {data && Object.keys(data).length > 0 && (
            <>
              {formsyDetails.CreatedById?.localeCompare(
                safyInfo?.user.azureId,
                undefined,
                { sensitivity: "accent" }
              ) !== 0 ? (
                formsyDetails.FinalSigned === "1" ? (
                  <div className="p-2 mb-2 bg-warning rounded">
                    This Bulk Case Note has been submitted.
                  </div>
                ) : (
                  <div className="p-2 mb-2 bg-info text-white rounded">
                    This Bulk Case Note is open/has not been submitted.
                  </div>
                )
              ) : null}
              {userBusinessUnit === "ccplive" || userIsAdmin ? (
                <FormSelect
                  name="SelectedState"
                  label={getFieldLabel(data.SelectedState)}
                  error={errors.SelectedState}
                  value={getFieldValue(data.SelectedState)}
                  options={bintiOptions.States}
                  onChange={handleSelectedStateChange}
                  disabled={
                    formDisabled ||
                    (!userIsAdmin &&
                      formsyDetails.CreatedById?.localeCompare(
                        safyInfo?.user.azureId,
                        undefined,
                        { sensitivity: "accent" }
                      ) !== 0)
                  }
                />
              ) : null}
              {!(userBusinessUnit === "ccplive" || userIsAdmin) ||
              getFieldValue(data.SelectedState) ? (
                <>
                  {!formDisabled ? (
                    <div className="row">
                      <div className="col">
                        <div className="border border-dark rounded p-2 bg-light">
                          <div className="mt-2">Filter by Assignment</div>
                          <div>
                            <FormRadioButton
                              name="assignment"
                              label=""
                              options={[
                                { name: "State", _id: "state" },
                                { name: "My Homes", _id: "my" },
                                { name: "Unassigned", _id: "unassigned" },
                              ]}
                              value={assignment}
                              onChange={(e) =>
                                setAssignment(e.currentTarget.value)
                              }
                            />
                          </div>
                          <div className="mt-2">Filter by Status</div>
                          <button
                            className={
                              filterType === "applying"
                                ? "btn btn-sm btn-success me-2"
                                : "btn btn-sm btn-safy-info me-2"
                            }
                            onClick={() => {
                              clearStatusRelatedFilters();
                              setFilterType("applying");
                            }}
                          >
                            {getFilterCount("Applying")}
                          </button>
                          <button
                            className={
                              filterType === "recruiting"
                                ? "btn btn-sm btn-success me-2"
                                : "btn btn-sm btn-safy-info me-2"
                            }
                            onClick={() => {
                              clearStatusRelatedFilters();
                              setFilterType("recruiting");
                            }}
                          >
                            {getFilterCount("Recruiting")}
                          </button>
                          <button
                            className={
                              filterType === "In Renewal"
                                ? "btn btn-sm btn-success me-2"
                                : "btn btn-sm btn-safy-info me-2"
                            }
                            onClick={() => {
                              clearStatusRelatedFilters();
                              setFilterType("In Renewal");
                            }}
                          >
                            {getFilterCount("In Renewal")}
                          </button>
                          {allStatuses === true ? (
                            <>
                              {/* <button
                  className={
                    filterType === ""
                      ? "btn btn-sm btn-success me-2"
                      : "btn btn-sm btn-safy-info me-2"
                  }
                  onClick={() => setFilterType("")}
                >
                  {getFilterCount("All")}
                </button> */}
                              <button
                                className={
                                  filterType === "recruiting_dropout"
                                    ? "btn btn-sm btn-success me-2"
                                    : "btn btn-sm btn-safy-info me-2"
                                }
                                onClick={() => {
                                  clearStatusRelatedFilters();
                                  setFilterType("recruiting_dropout");
                                }}
                              >
                                {getFilterCount("Recruiting Dropout")}
                              </button>
                              <button
                                className={
                                  filterType === "withdrawn"
                                    ? "btn btn-sm btn-success me-2"
                                    : "btn btn-sm btn-safy-info me-2"
                                }
                                onClick={() => {
                                  clearStatusRelatedFilters();
                                  setFilterType("withdrawn");
                                }}
                              >
                                {getFilterCount("Withdrawn")}
                              </button>
                              <button
                                className={
                                  filterType === "denied"
                                    ? "btn btn-sm btn-success me-2"
                                    : "btn btn-sm btn-safy-info me-2"
                                }
                                onClick={() => {
                                  clearStatusRelatedFilters();
                                  setFilterType("denied");
                                }}
                              >
                                {getFilterCount("Denied")}
                              </button>
                              <button
                                className={
                                  filterType === "closed"
                                    ? "btn btn-sm btn-success me-2"
                                    : "btn btn-sm btn-safy-info me-2"
                                }
                                onClick={() => {
                                  clearStatusRelatedFilters();
                                  setFilterType("closed");
                                }}
                              >
                                {getFilterCount("Closed")}
                              </button>
                            </>
                          ) : null}
                          {safyInfo.user.modules.includes("Admin") ? (
                            <button
                              className="btn btn-sm border mr2"
                              onClick={() => setAllStatuses(!allStatuses)}
                            >
                              ...
                            </button>
                          ) : null}
                          <br />
                          <ExpandDiv
                            className="my-2 border-bottom border-dark"
                            label="Additional Filters"
                            title="Filters"
                          >
                            <button
                              className={getAdditionalFilterClass("NCD-PAST")}
                              onClick={() =>
                                addRemoveAdditionalFilter("NCD-PAST")
                              }
                            >
                              Next Contact Date in Past
                            </button>
                            <button
                              className={getAdditionalFilterClass("NCD-7")}
                              onClick={() => addRemoveAdditionalFilter("NCD-7")}
                            >
                              Next Contact Date In Next 7 Days
                            </button>
                            <button
                              className={getAdditionalFilterClass("LCD-30")}
                              onClick={() =>
                                addRemoveAdditionalFilter("LCD-30")
                              }
                            >
                              Last Contact Date More Than 30 Days
                            </button>
                            <button
                              className={getAdditionalFilterClass("NOLCD")}
                              onClick={() => addRemoveAdditionalFilter("NOLCD")}
                            >
                              No Contact
                            </button>
                            <button
                              className={getAdditionalFilterClass("TRAINING")}
                              onClick={() =>
                                addRemoveAdditionalFilter("TRAINING")
                              }
                            >
                              In Training
                            </button>
                            {filterType === "applying" || filterType === "" ? (
                              <>
                                <button
                                  className={getAdditionalFilterClass(
                                    "ALD-PAST30"
                                  )}
                                  onClick={() =>
                                    addRemoveAdditionalFilter("ALD-PAST30")
                                  }
                                >
                                  Approval Date Estimate Last 30 Days
                                </button>
                                <button
                                  className={getAdditionalFilterClass("ALD-30")}
                                  onClick={() =>
                                    addRemoveAdditionalFilter("ALD-30")
                                  }
                                >
                                  Approval Date Estimate in Next 30 Days
                                </button>
                              </>
                            ) : null}
                            {filterType === "In Renewal" ||
                            filterType === "" ? (
                              <>
                                <button
                                  className={getAdditionalFilterClass(
                                    "RECERT-60"
                                  )}
                                  onClick={() =>
                                    addRemoveAdditionalFilter("RECERT-60")
                                  }
                                >
                                  Recert Date in Next 60 Days
                                </button>
                              </>
                            ) : null}
                            <div>Tags</div>
                            {availableTags.map((tag) => (
                              <button
                                className={getTagFilterClass(tag)}
                                onClick={() => addRemoveTagFilter(tag)}
                              >
                                {tag}
                              </button>
                            ))}
                          </ExpandDiv>
                          <button
                            className="btn btn-primary"
                            onClick={handleSelectAll}
                          >
                            Select {filteredData.length}
                          </button>
                          <button
                            className="btn btn-danger ms-2"
                            onClick={handleClearAll}
                          >
                            Clear All
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="row mt-2">
                    <div className="col">
                      <label htmlFor="SelectedRecipients">
                        <span>{getFieldLabel(data.SelectedRecipients)}</span>
                        {csvData.length > 0 ? (
                          <CSVLink
                            filename={`${moment(
                              getFieldValue(data.Date)
                            ).format("M-D-YY")} - ${getFieldValue(
                              data.Subject
                            )}`}
                            className="ms-2"
                            data={csvData}
                          >
                            Download Mailing List
                          </CSVLink>
                        ) : null}
                        {getFieldArray(data.ProcessErrors).length > 0 ? (
                          <>
                            <br />
                            <span>
                              Errors shaded in{" "}
                              <span className="text-danger">RED</span>
                            </span>
                          </>
                        ) : null}
                      </label>
                      <Multiselect
                        name="SelectedRecipients"
                        data={recipientOptions}
                        dataKey="_id"
                        textField="name"
                        value={getFieldArray(data.SelectedRecipients)}
                        onChange={handleSelectedRecipientsChange}
                        className="mt-2"
                        disabled={
                          formDisabled ||
                          formsyDetails.CreatedById?.localeCompare(
                            safyInfo?.user.azureId,
                            undefined,
                            { sensitivity: "accent" }
                          ) !== 0
                        }
                        renderTagValue={({ item }) => (
                          <span
                            className={
                              getFieldArray(data.ProcessErrors).includes(
                                item._id
                              )
                                ? "fw-bold text-danger"
                                : getFieldArray(data.BulkProcessed).includes(
                                    item._id
                                  )
                                ? "text-success"
                                : ""
                            }
                          >
                            {item.name}
                          </span>
                        )}
                      />
                    </div>
                    <div className="col-3">
                      <FormInput
                        label="# of Recipients Selected:"
                        value={getFieldArray(data.SelectedRecipients).length}
                        onChange={handleChange}
                        commentsHandler={handleComments}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormSelect
                        name="Type"
                        label={getFieldLabel(data.Type)}
                        error={errors.Type}
                        value={getFieldValue(data.Type)}
                        options={bintiOptions.ContactTypes}
                        onChange={handleChange}
                        commentsHandler={handleComments}
                        disabled={
                          formDisabled ||
                          formsyDetails.CreatedById?.localeCompare(
                            safyInfo?.user.azureId,
                            undefined,
                            { sensitivity: "accent" }
                          ) !== 0
                        }
                      />
                    </div>
                    <div className="col-3">
                      <FormInput
                        name="Date"
                        label={
                          getFieldValue(data.Type) === "next_planned_contact"
                            ? "Future Date"
                            : getFieldLabel(data.Date)
                        }
                        error={errors.Date}
                        value={getFieldValue(data.Date)}
                        onChange={handleChange}
                        commentsHandler={handleComments}
                        disabled={
                          formDisabled ||
                          formsyDetails.CreatedById?.localeCompare(
                            safyInfo?.user.azureId,
                            undefined,
                            { sensitivity: "accent" }
                          ) !== 0
                        }
                        type="date"
                      />
                    </div>
                    <div className="col">
                      <FormInput
                        name="Subject"
                        label={getFieldLabel(data.Subject)}
                        error={errors.Subject}
                        value={getFieldValue(data.Subject)}
                        onChange={handleChange}
                        commentsHandler={handleComments}
                        disabled={
                          formDisabled ||
                          formsyDetails.CreatedById?.localeCompare(
                            safyInfo?.user.azureId,
                            undefined,
                            { sensitivity: "accent" }
                          ) !== 0
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    {needsContactMethod ? (
                      <div className="col-4 clearfix">
                        <FormSelect
                          name="ContactMethod"
                          label={getFieldLabel(data.ContactMethod)}
                          error={errors.ContactMethod}
                          value={getFieldValue(data.ContactMethod)}
                          options={bintiOptions.ContactMethods}
                          onChange={handleChange}
                          commentsHandler={handleComments}
                          disabled={
                            formDisabled ||
                            formsyDetails.CreatedById?.localeCompare(
                              safyInfo?.user.azureId,
                              undefined,
                              { sensitivity: "accent" }
                            ) !== 0
                          }
                          divClassName="float-start"
                        />
                      </div>
                    ) : null}
                    {getFieldValue(data.Type) === "approval_date_estimate" ? (
                      <div className="col-4">
                        <FormInput
                          name="EstimatedApprovalDate"
                          label={getFieldLabel(data.EstimatedApprovalDate)}
                          error={errors.EstimatedApprovalDate}
                          value={getFieldValue(data.EstimatedApprovalDate)}
                          onChange={handleChange}
                          commentsHandler={handleComments}
                          disabled={
                            formDisabled ||
                            formsyDetails.CreatedById?.localeCompare(
                              safyInfo?.user.azureId,
                              undefined,
                              { sensitivity: "accent" }
                            ) !== 0
                          }
                          type="date"
                        />
                      </div>
                    ) : null}
                  </div>
                  <FormInput
                    name="Body"
                    label={getFieldLabel(data.Body)}
                    error={errors.Body}
                    value={getFieldValue(data.Body)}
                    onChange={handleChange}
                    commentsHandler={handleComments}
                    disabled={
                      formDisabled ||
                      formsyDetails.CreatedById?.localeCompare(
                        safyInfo?.user.azureId,
                        undefined,
                        { sensitivity: "accent" }
                      ) !== 0
                    }
                  />
                  {getFieldValue(data.Type) !== "next_planned_contact" &&
                  needsContactMethod ? (
                    <>
                      <div className="row">
                        <div className="col">
                          <FormCheckbox
                            name="NeedNext"
                            label={getFieldLabel(data.NeedNext)}
                            error={errors.NeedNext}
                            checked={getFieldValue(data.NeedNext) === "true"}
                            onChange={handleChange}
                            commentsHandler={handleComments}
                            disabled={
                              formDisabled ||
                              formsyDetails.CreatedById?.localeCompare(
                                safyInfo?.user.azureId,
                                undefined,
                                { sensitivity: "accent" }
                              ) !== 0
                            }
                            divClassName="ms-3"
                          />
                        </div>
                        {getFieldValue(data.NeedNext) === "true" ? (
                          <>
                            <div className="col">
                              <FormInput
                                name="NextContactDate"
                                label={getFieldLabel(data.NextContactDate)}
                                error={errors.NextContactDate}
                                value={getFieldValue(data.NextContactDate)}
                                onChange={handleChange}
                                commentsHandler={handleComments}
                                disabled={
                                  formDisabled ||
                                  formsyDetails.CreatedById?.localeCompare(
                                    safyInfo?.user.azureId,
                                    undefined,
                                    { sensitivity: "accent" }
                                  ) !== 0
                                }
                                type="date"
                              />
                            </div>
                            <div className="col">
                              <FormInput
                                name="NextContactSubject"
                                label={getFieldLabel(data.NextContactSubject)}
                                error={errors.NextContactSubject}
                                value={getFieldValue(data.NextContactSubject)}
                                onChange={handleChange}
                                commentsHandler={handleComments}
                                disabled={
                                  formDisabled ||
                                  formsyDetails.CreatedById?.localeCompare(
                                    safyInfo?.user.azureId,
                                    undefined,
                                    { sensitivity: "accent" }
                                  ) !== 0
                                }
                              />
                            </div>
                            <div className="col">
                              <FormSelect
                                name="NextContactMethod"
                                label={getFieldLabel(data.NextContactMethod)}
                                error={errors.NextContactMethod}
                                value={getFieldValue(data.NextContactMethod)}
                                options={bintiOptions.ContactMethods}
                                onChange={handleChange}
                                commentsHandler={handleComments}
                                disabled={
                                  formDisabled ||
                                  formsyDetails.CreatedById?.localeCompare(
                                    safyInfo?.user.azureId,
                                    undefined,
                                    { sensitivity: "accent" }
                                  ) !== 0
                                }
                              />
                            </div>
                          </>
                        ) : null}
                      </div>
                      {getFieldValue(data.NeedNext) === "true" ? (
                        <FormInput
                          name="NextContactBody"
                          label={getFieldLabel(data.NextContactBody)}
                          error={errors.NextContactBody}
                          value={getFieldValue(data.NextContactBody)}
                          onChange={handleChange}
                          commentsHandler={handleComments}
                          disabled={
                            formDisabled ||
                            formsyDetails.CreatedById?.localeCompare(
                              safyInfo?.user.azureId,
                              undefined,
                              { sensitivity: "accent" }
                            ) !== 0
                          }
                        />
                      ) : null}
                    </>
                  ) : null}
                </>
              ) : null}
            </>
          )}
          <div className="clearfix" style={{ marginBottom: "250px" }}>
            <div className="float-end">
              {/* {formsyDetails.FinalSigned &&
              formsyDetails.CreatedById?.localeCompare(
                safyInfo?.user.azureId,
                undefined,
                { sensitivity: "accent" }
              ) === 0 ?  
              <div
                className="btn btn-success m-2 d-print-none"
                onClick={markFinalSigned}
              >
                Get Email List
              </div> : null} */}
              {!formDisabled &&
              formsyDetails.CreatedById?.localeCompare(
                safyInfo?.user.azureId,
                undefined,
                { sensitivity: "accent" }
              ) === 0 &&
              csvData.length > 0 ? (
                <div
                  className="btn btn-success m-2 d-print-none"
                  onClick={markFinalSigned}
                >
                  Submit
                </div>
              ) : null}
              <div
                className="btn btn-primary m-2 d-print-none"
                onClick={() => {
                  handleSubmit(null, null, null, null);
                }}
              >
                Save
              </div>
              <div
                className="btn btn-danger m-2 d-print-none"
                onClick={() => {
                  navigate(-1);
                }}
              >
                Cancel
              </div>
              {submissionid &&
              (userIsAdmin ||
                formsyDetails.CreatedById?.localeCompare(
                  safyInfo?.user.azureId,
                  undefined,
                  { sensitivity: "accent" }
                ) === 0) ? (
                <div className="btn m-2 d-print-none" onClick={handleDelete}>
                  <i className="fa-solid fa-trash-can fa-xl"></i>
                </div>
              ) : null}
              {/* {!formDisabled &&
                (!submissionid ||
                  userIsAdmin ||
                  formsyDetails.CreatedById?.localeCompare(
                    safyInfo?.user.azureId,
                    undefined,
                    { sensitivity: "accent" }
                  ) === 0) ? ( */}
              {/* ) : null} */}
            </div>
          </div>
          <Comment
            showModal={showComment}
            commentToEdit={commentToEdit}
            onHide={() => {
              setShowComment(false);
              setCommentToEdit(undefined);
            }}
            onSave={onCommentSave}
            fields={commentFields()}
          />
          {showShare ? (
            <ShareModal
              showShare={showShare}
              onHide={() => setShowShare(false)}
              onSend={handleShareSend}
              submissionId={submissionid}
            />
          ) : null}
        </div>
      </div>
    </>
  );
}

export default BulkCaseNotev2;
